window.addEventListener('load', function () {
  const selectors = {
    header: '[data-site-header]',
    headerCartCount: '[data-header-cart-count]',
    rechargeOptions: 'input.subscription_options',
    rechargeFrequency: '#rechargeFrequency',
    rechargeFormSubmit: '[data-product-atc]',
    rechargeForm: 'form[data-product-form]',
    flyoutWrapper: '[data-atc-banner]',
    flyoutClose: '[data-atc-banner-close]',
    flyoutProductImage: '[data-atc-banner-product-image]',
    flyoutProductTitle: '[data-atc-banner-product-title]',
    flyoutProductVariant: '[data-atc-banner-product-options]',
    flyoutProductQuantity: '[data-atc-banner-product-price-quantity]',
    flyoutProductPrice: '[data-atc-banner-product-price-value]',
    flyoutProductDiscount: '[data-atc-banner-product-discounts]',
    flyoutCartTotal: '[data-atc-banner-cart-subtotal]',
    flyoutCartButton: '[data-atc-banner-cart-button]',
    flyoutCheckoutButton: '[data-atc-banner-checkout-button]'
  }

  // Get Subscription Choice
  let rechargeOption;
  $('body').on('change', selectors.rechargeOptions, function (evt) {
    rechargeOption = '';
    rechargeOption = evt.currentTarget.value;
    hideAtcButton();
    atcDisable();

    if (rechargeOption === 'subscription') {
      document.querySelectorAll('.product-form--atc-button').forEach(button => {
        button.classList.add('recharge--hide-button');
      })
      document.querySelectorAll('.recharge-add-to-cart-button').forEach(button => {
        button.classList.remove('recharge--hide-button');
      })
    } else {
      document.querySelectorAll('.product-form--atc-button').forEach(button => {
        button.classList.remove('recharge--hide-button');
      })
      document.querySelectorAll('.recharge-add-to-cart-button').forEach(button => {
        button.classList.add('recharge--hide-button');
      })
    }
  });

  // Get Shipping Frequency
  let shippingFrequency;
  $('body').on('change', selectors.rechargeFrequency, function (evt) {
    shippingFrequency = "";
    shippingFrequency = evt.currentTarget.value;
    setShippingIntervalFrequency();
    atcDisable();
  });

  // Set Shipping Frequency
  let shippingIntervalFrequency = 1;
  let shippingIntervalUnit = "Weeks";
  const setShippingIntervalFrequency = () => {
    shippingIntervalFrequency = "";
    shippingIntervalUnit = "";
    switch (shippingFrequency) {
      case 'weekly':
        shippingIntervalFrequency = 1;
        shippingIntervalUnit = 'Weeks';
        break;
      case 'biweekly':
        shippingIntervalFrequency = 2;
        shippingIntervalUnit = 'Weeks';
        break
      case 'monthly':
        shippingIntervalFrequency = 1;
        shippingIntervalUnit = 'Months';
        break;
      case 'sixWeeks':
        shippingIntervalFrequency = 6;
        shippingIntervalUnit = 'Weeks';
        break;
      case 'bimonthly':
        shippingIntervalFrequency = 2;
        shippingIntervalUnit = 'Months';
        break;
      default:
        shippingIntervalFrequency = 1;
        shippingIntervalUnit = 'Months';
        break;
    }
  }

  // Disabled Recharge AtC button if option changed
  $('body').on('change', '.option-value', function (evt) {
    atcDisable();
  })

  // Disable Recharge AtC if AtC button is disabled
  const atcDisable = () => {
    let atcButton = document.querySelectorAll('.product-form--atc-button');
    let rechargeAtcButton = document.querySelectorAll('.recharge-add-to-cart-button');
    atcButton.forEach(button => {
      if (button.hasAttribute('disabled')) {
        rechargeAtcButton.forEach(rechargeButton => rechargeButton.setAttribute('disabled', 'true'));
        rechargeAtcButton.forEach(rechargeButton => rechargeButton.setAttribute('value', 'Choose Options'));
      } else {
        rechargeAtcButton.forEach(rechargeButton => rechargeButton.removeAttribute('disabled'));
        rechargeAtcButton.forEach(rechargeButton => rechargeButton.setAttribute('value', 'Add to Cart'));
      }
    })
  }

  const hideAtcButton = () => {
    if (rechargeOption === 'subscription') {
      document.querySelector('.product-form--atc-button').classList.add('recharge--hide-button');
      document.querySelector('.recharge-add-to-cart-button').classList.remove('recharge--hide-button');
    } else {
      document.querySelector('.product-form--atc-button').classList.remove('recharge--hide-button');
      document.querySelector('.recharge-add-to-cart-button').classList.add('recharge--hide-button');
    }
  }



  // const formReset = () => {
  //   document.querySelector('[data-product-form]').reset();
  // }

  // Rich, c'd out
  // $('selectors.rechargeForm').on('submit', function (evt) {
  //   if (rechargeOption == 'subscription') {
  //     evt.preventDefault();
  //     evt.stopPropagation();

  //     // subscription add to cart
  //     let quantity = parseInt($('#product-quantity-select').val());

  //     addSubscriptionToCart(variantId, quantity, shippingIntervalFrequency, shippingIntervalUnit);
  //   }
  // })

  // function addSubscriptionToCart(variantId, quantity, shipping_interval_frequency, shipping_interval_unit_type) {
  //   let properties = {
  //     'shipping_interval_frequency': shipping_interval_frequency,
  //     'shipping_interval_unit_type': shipping_interval_unit_type
  //   }

  //   let data = {
  //     items: [
  //       {
  //         id: variantId,
  //         quantity: quantity,
  //         properties: properties
  //       }
  //     ]
  //   }

  //   $.post('/cart/add.js', data);
  //   setTimeout(function () {
  //     $.get('/cart.js', function (data) {
  //       let $flyout = $(selectors.flyoutWrapper).clone();
  //       let cart = JSON.parse(data);
  //       let cartItems = cart.items;
  //       let cartItemsCount = cart.item_count;
  //       let cartTotal = `$${(cart.total_price / 100.00).toString()}`;
  //       let newItem = cartItems[0];
  //       $flyout.find(selectors.flyoutProductImage).html('<img src="' + newItem.image + '" alt="' + newItem.product_title + '" />');
  //       $flyout.find(selectors.flyoutProductTitle).html(newItem.product_title);
  //       $flyout.find(selectors.flyoutProductVariant).html(newItem.variant_title);
  //       $flyout.find(selectors.flyoutProductQuantity).html(`${quantity} x`);
  //       $flyout.find(selectors.flyoutProductPrice).html(`$${(newItem.price / 100.00).toString()}`)
  //       $flyout.find(selectors.flyoutProductDiscount).attr('style', 'display: none');
  //       $flyout.find(selectors.flyoutCartTotal).html(cartTotal);
  //       $flyout.find(selectors.flyoutCartButton).html(`View cart (<span>${cartItemsCount}</span>)`);
  //       $flyout.addClass('visible');
  //       $flyout.find(selectors.flyoutClose).on('click', function (evt) {
  //         evt.preventDefault();
  //         $flyout.removeClass('visible');
  //       })
  //       $(selectors.header).append($flyout);
  //       $(selectors.headerCartCount).attr('data-header-cart-count', cartItemsCount);
  //     })
  //   }, 1250);
  // };

  window.goToCheckout = function () {
    // check for subscriptions
    let hasSubscription = false;
    let cartItems;
    let properties;
    let subscription_frequency;
    let subscription_unit;
    $.get('/cart.js', function (data) {
      let cart = JSON.parse(data);
      console.log(cart);
      console.log(cart.items);
      let cartItems = cart.items;
      for (let i = 0; i < cartItems.length; i++) {
        properties = cartItems[i].properties;
        if (properties['shipping_interval_frequency'] && properties['shipping_interval_unit_type']) {
          hasSubscription = true;
        }
      }
      if (hasSubscription) {
        let token = getCookie('cart');
        //let myshopify_domain = "hydrantstore.myshopify.com";
        let myshopify_domain = Shopify.shop;
        try {
          // Cross-domain tracking with Google Analytics
          var ga_linker = ga.getAll()[0].get('linkerParam');
        } catch (e) {
          // 'ga' is not available
          var ga_linker = '';
        }
        let customer_param = "";
        var checkout_url = 'https://checkout.rechargeapps.com/r/checkout?myshopify_domain=' + myshopify_domain + '&cart_token=' + token + '&' + ga_linker + '&' + customer_param;
        window.location.href = checkout_url;
      } else {
        window.location = "/checkout";
      }
    })
  }

  function getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  };

  // Rich C, added new Recharge code below
  $('body').on('click', '.recharge-add-to-cart-button', function (evt) {
    let quantity = parseInt($('#product-quantity-select').val());
    let variantId = $("select[name='id']").val();
    addItemToCart(variantId, quantity, shippingIntervalFrequency.toString(), shippingIntervalUnit)
  })

  function addItemToCart(variant_id, qty, frequency, unit_type) {
    var data = {
      "id": variant_id,
      "quantity": qty,
      "properties": {
        "shipping_interval_frequency": frequency,
        "shipping_interval_unit_type": unit_type
      }
    }
    jQuery.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: data,
      dataType: 'json',
      success: function () {
        window.location.href = '/cart';
      }
    });
  }
})








